module.exports = __webpack_public_path__ + "img/banner.599863de.png";